import { useEffect, useState } from "react";

import { useTheme } from "@mui/material";

import { hslStringToRgbaString } from "@/common/helpers/colors";

export const useFetchHeartsAnimation = () => {
  const theme = useTheme();
  const [heartsAnimation, setHeartsAnimation] = useState<Record<string, unknown> | null>(null);
  const heartColor = hslStringToRgbaString(theme.palette.forms.surface.moderate);

  useEffect(() => {
    const fetchHeartsAnimationData = async () => {
      let animationData = await import("./hearts-animation.json");
      let animationDataString = JSON.stringify(animationData);

      animationDataString = animationDataString.replace(
        /"k":\s*\[\d+(\.\d+)?,\s*\d+(\.\d+)?,\s*\d+(\.\d+)?,\s*1\]/g,
        `"k": ${heartColor}`
      );

      animationData = JSON.parse(animationDataString);

      setHeartsAnimation(animationData);
    };

    fetchHeartsAnimationData();

    return () => {
      setHeartsAnimation(null);
    };
  }, [heartColor]);

  return heartsAnimation;
};
